export const REQUEST_CREATE_VIEW_TYPE = 'JSMRequestCreate' as const;
